import React from 'react';
import { Button, Box } from '@mui/material';

const CustomButton = ({
  text = 'Button',
  icon: Icon = null,
  onClick = () => { },
  sx = {},
  iconSx = {},
  direction
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor: 'var( --custom-gold)',
        color: 'white',
        fontSize: '16px',
        paddingRight: '10px',
        borderRadius: '50px',
        '&:hover': {
          backgroundColor: 'var(--primary-color-hover)',
          '& .icon-box': {
            backgroundColor: '#fff',
            color: 'var(--primary-color-hover)',
          },
        },
        marginTop: '30px',
        marginBottom: { md: '0px', xs: "30px" },
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        justifyContent: 'center',
        flexDirection: direction === "rtl" ? "row-reverse" : "row",
        fontWeight: 700,
        ...sx,
      }}
    >
      {text}
      {Icon && (
        <Box
          className="icon-box"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#fff',
            borderRadius: '50%',
            padding: '8px',
            color: 'var(--custom-gold)',
            ...iconSx, // Allow overriding icon styles
          }}
        >
          <Icon fontSize="20px" />
        </Box>
      )}
    </Button>
  );
};

export default CustomButton;
